import DriverPlanListRequest from "../../../../api/raily/driver/plan/list/driver-plan-list.request";
import DriverPlanListParams from "./driver-plan-list-params";

const create = (params: DriverPlanListParams): DriverPlanListRequest => {
  return {
    driverUuid: params.driverUuid,
  };
};

const driverPlanListParamsFactory = {
  create,
};

export default driverPlanListParamsFactory;
